import { HOST } from '@/lib/host';
import { OmniumStore } from '@fagmobler/omnium';

export async function fetchStore(storeId: string): Promise<OmniumStore | null> {
  const res = await fetch(`${HOST}/api/stores/${storeId}`, {
    next: { revalidate: 60 },
  });

  if (res.status !== 200) return null;

  const data = (await res.json()) as OmniumStore;

  return data;
}
